module.exports = __webpack_public_path__ + "img/20.bea58b4f.jpg";